// src/components/atoms/Radio/Radio.tsx
import React, { ChangeEvent, useEffect, useRef } from 'react'
import { radio, radioMark, wrapper, label } from './Radio.css'

export interface RadioProps {
  checked: boolean
  onChange: (v: boolean) => void
  name: string // 라디오 그룹을 구분하기 위한 name 속성
  indeterminate?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  showIcon?: boolean
  label?: string
}

export const Radio: React.FC<RadioProps> = ({
  checked,
  onChange,
  name,
  indeterminate = false,
  disabled = false,
  size = 'medium',
  showIcon = false,
  label: text,
}) => {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate
  }, [indeterminate])

  const state = indeterminate ? 'indeterminate' : checked ? 'checked' : 'unchecked'

  return (
    <label className={wrapper} style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        ref={ref}
        type="radio"
        name={name}
        className={radio}
        checked={checked}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
      />
      <span
        className={radioMark({ size, state, showIcon, disabled })}
      />
      {text && <span className={`text-sm ${label}`}>{text}</span>}
    </label>
  )
}